/*
  assets/cesium-config.js — CESIUM-CONFIG-04
  Owner: immutable client configuration consumed by assets/cesium-integration.js.

  Owns:
  - Optional Cesium Ion public access token handoff.
  - Canonical Hong Kong camera presets.
  - Camera animation duration.

  Does not own:
  - Viewer initialization or DOM mutation.
  - Product execution eligibility.
  - GFun consumption or reward policy.
  - API, delivery, result-surface or entitlement derivation.
*/
(function () {
  'use strict';

  var VERSION = 'v4-config-only';
  if (window.CesiumConfig && window.CesiumConfig.__version === VERSION) return;

  function cleanString(value) {
    return typeof value === 'string' ? value.trim() : '';
  }

  function freezeLocation(location) {
    return Object.freeze({
      name: cleanString(location.name),
      lon: Number(location.lon),
      lat: Number(location.lat),
      height: Number(location.height),
      heading: Number(location.heading),
      pitch: Number(location.pitch),
      roll: Number(location.roll)
    });
  }

  var locations = Object.freeze({
    hongkong: freezeLocation({
      name: 'Hong Kong',
      lon: 114.1694,
      lat: 22.3193,
      height: 15000,
      heading: 0,
      pitch: -45,
      roll: 0
    }),
    victoria: freezeLocation({
      name: 'Victoria Harbour',
      lon: 114.1747,
      lat: 22.2899,
      height: 2200,
      heading: 0,
      pitch: -58,
      roll: 0
    }),
    peak: freezeLocation({
      name: 'The Peak',
      lon: 114.1489,
      lat: 22.2710,
      height: 1200,
      heading: 180,
      pitch: -36,
      roll: 0
    }),
    tsimshatsui: freezeLocation({
      name: 'Tsim Sha Tsui',
      lon: 114.1722,
      lat: 22.2976,
      height: 1600,
      heading: 0,
      pitch: -52,
      roll: 0
    }),
    central: freezeLocation({
      name: 'Central',
      lon: 114.1577,
      lat: 22.2819,
      height: 1300,
      heading: 0,
      pitch: -55,
      roll: 0
    }),
    airport: freezeLocation({
      name: 'Hong Kong International Airport',
      lon: 113.9148,
      lat: 22.3080,
      height: 3200,
      heading: 270,
      pitch: -40,
      roll: 0
    })
  });

  var CONFIG = Object.freeze({
    __version: VERSION,
    ionAccessToken: cleanString(window.CESIUM_ION_TOKEN),
    defaultView: locations.hongkong,
    locations: locations,
    animation: Object.freeze({
      duration: 1.8
    })
  });

  window.CesiumConfig = CONFIG;
  window.GCityCesiumConfig = CONFIG;

  try {
    window.dispatchEvent(new CustomEvent('gcity:cesium:config-ready', {
      detail: {
        source: 'cesium-config.js',
        version: CONFIG.__version,
        tokenConfigured: CONFIG.ionAccessToken !== ''
      }
    }));
  } catch (_error) {}
})();
